module.exports = __webpack_public_path__ + "img/USDC.0583a707.png";